<template>
  <transition name="snackbar">
    <div class="snackbar" :class="[position]" v-if="show">
      <slot>
        <span class="message">{{ message }}</span>
        <button @click="onButtonClicked" class="small">{{ buttonTitle }}</button>
      </slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    /**
     * Visibility of the snackbar
     */
    show: {
      type: Boolean,
      default: false,
    },
    /**
     * Message in the snackbar
     */
    message: String,
    /**
     * Tile of the button in the snackbar
     */
    buttonTitle: {
      type: String,
      default: 'Dismiss',
    },
    /**
     * Position of the snackbar
     */
    position: {
      type: String,
      default: 'left',
    },
  },
  methods: {
    onButtonClicked() {
      /**
       * Emit event to update show prop
       * @property {boolean} value
       */
      this.$emit('update:show', false);
      /**
       * Emit click event
       * @property {none}
       */
      this.$emit('click');
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

.snackbar-enter-active {
  transition: opacity 200ms ease-out, transform 200ms ease-out;
}

.snackbar-leave-active {
  transition: opacity 200ms ease-in, transform 200ms ease-in;
}

.snackbar-enter-to,
.snackbar-leave-from {
  opacity: 1;
  transform: translateY(0px);
  z-index: 999;
}

.snackbar-enter-from,
.snackbar-leave-to {
  opacity: 0;
  transform: translateY(80px);
  z-index: -1;
}

.snackbar {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 24px;
  padding: 14px 12px;
  z-index: 999;
  @mixin overlay;
  width: 320px;

  &.top {
    bottom: unset;
    top: 24px;
  }

  &.left {
    left: 24px;
  }

  &.middle {
    margin: auto;
  }

  &.right {
    right: 24px;
  }

  .message {
    flex: 3;
    padding: 0px var(--space-2);
  }

  button {
    flex: 1;
  }

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    margin: 0 12px;
    width: calc(100% - 48px);
    &.top,
    &.right,
    &.left,
    &.middle {
      left: 0;
      right: 0;
    }
  }
}
</style>
